import { THEME_KEY as DarkThemeKey, THEME as DarkTheme } from './dark';

export const ALL_THEME_OVERRIDES = {
  // insert new themes below following the pattern of:
  // [THEME_KEY]: THEME,
  [DarkThemeKey]: DarkTheme,
};

export function getThemeOverrideByKey(themeKey) {
  return ALL_THEME_OVERRIDES[themeKey] || {};
}
